<form id="myForm" (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">

  <div fxFlex="400px" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="20px">
    <mat-slide-toggle fxFlex formControlName="checkExternalId" color="primary">
      <label class="form-label">Check external id</label>
    </mat-slide-toggle>

    <mat-slide-toggle color="primary" formControlName="receiptTimeConstraintEnabled">
      <label>Receipt time constraint</label>
    </mat-slide-toggle>
    @if (form.value.receiptTimeConstraintEnabled) {
      <app-time-constraint [formControl]="form.controls.receiptTimeConstraint"></app-time-constraint>
    }
    @if (campaignId) {
      <div class="import">
        <lib-button icon="add" (buttonClick)="csvFileForImport.click()" tooltip="Import codes">Import file</lib-button>
        <input hidden type="file" (change)="importFromCsv($event)" id="csvFileForImport" #csvFileForImport>
      </div>
    }
  </div>

</form>